import { render, staticRenderFns } from "./usersTable.vue?vue&type=template&id=05665a91&"
import script from "./usersTable.vue?vue&type=script&lang=js&"
export * from "./usersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports